export const ActionsCardsData = [
  {
    id: 1,
    title: 'Додайте 10 іменин до календаря привітань',
    image: '/src/images/CatWithCake.jpg',
    imageAlt: 'Котик з тортом',
    rewards: [
      'Бонусне створення листівки безкоштовно',
      'Бонусна правка (повторне створення)'
    ],
    additionalText: 'Та отримуйте зручні нагадування про ці події щоб ніколи не забути привітати',
    limitText: 'Акція буде доступна не більше 3-х разів',
    description: 'Заповніть зручний календар іменин про Ваші друзів щоб ніколи не забути привітати їм як досягнути за більш ніж тиждень',
    buttonText: 'Додати події',
    buttonType: 'primary'
  },
 
];